
import { useContext, useEffect, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import {
  FaAward,
  FaBatteryFull,
  FaGlobe,
  FaShieldAlt,
  FaUsers,
  FaHandshake,
  FaStoreAlt,
  FaUserTie,
  FaBuilding,
  FaBriefcase,
  FaStore,
  FaUser,
  FaMousePointer,
  FaUserCheck,
  FaSignInAlt,
  FaShareAlt,
  FaCopy,
  FaQrcode,
  FaCamera,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { AuthContext } from "../context";

const Home = () => {
  const MARATHON_REGISTRATION_URL =
  "https://lifeonplus.in/marathon-registration";
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [showSharePanel, setShowSharePanel] = useState(false);
  const [shareMessage, setShareMessage] = useState("");

  const navigate = useNavigate();
  const { openAccountModal } = useContext(AuthContext);

  const getShareUrl = () => MARATHON_REGISTRATION_URL;

  const handleCopyLink = async () => {
    const url = MARATHON_REGISTRATION_URL;

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = url;
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.select();

        const copied = document.execCommand("copy");
        document.body.removeChild(textArea);

        if (!copied) {
          throw new Error("Copy failed");
        }
      }

      setShareMessage("Link copied successfully!");
    } catch (copyError) {
      setShareMessage("Copy failed. Please copy the link from your browser.");
    }
  };

  const handleShareLink = async () => {
    const url = MARATHON_REGISTRATION_URL;

    if (navigator.share) {
      try {
        await navigator.share({
          title: "LifeOnPlus",
          text: "Explore LifeOnPlus Digital Healthcare.",
          url,
        });
      } catch (shareError) {
        if (shareError.name !== "AbortError") {
          setShareMessage("Unable to share. Please copy the link.");
        }
      }
    } else {
      await handleCopyLink();
    }
  };

  const marathonRegistrationUrl = MARATHON_REGISTRATION_URL;

  const handleCopyMarathonLink = async () => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(marathonRegistrationUrl);
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = marathonRegistrationUrl;
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.select();
        const copied = document.execCommand("copy");
        document.body.removeChild(textArea);
        if (!copied) throw new Error("Copy failed");
      }
      setShareMessage("Marathon registration link copied!");
    } catch (copyError) {
      setShareMessage("Copy failed. Please copy the registration link manually.");
    }
  };

  const handleShareMarathonLink = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "LifeOnPlus Marathon Registration",
          text: "Join the LifeOnPlus Marathon! Register here:",
          url: marathonRegistrationUrl,
        });
      } catch (shareError) {
        if (shareError.name !== "AbortError") {
          setShareMessage("Unable to share. Please copy the registration link.");
        }
      }
    } else {
      await handleCopyMarathonLink();
    }
  };

  const handleShareMarathonQR = async () => {
    const canvas = document.querySelector(".marathon-registration-qr");
    if (!canvas) {
      setShareMessage("QR code is not available. Please try again.");
      return;
    }

    try {
      const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
      if (!blob) throw new Error("Could not create QR image");
      const file = new File([blob], "lifeonplus-marathon-qr.png", { type: "image/png" });
      if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          title: "LifeOnPlus Marathon QR Code",
          text: "Scan this QR code to register for the LifeOnPlus Marathon.",
          files: [file],
        });
      } else {
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = "lifeonplus-marathon-qr.png";
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(downloadUrl);
        setShareMessage("QR code downloaded. You can now share the image.");
      }
    } catch (shareError) {
      if (shareError.name !== "AbortError") {
        setShareMessage("Unable to share QR code. Please try again.");
      }
    }
  };

  const handleScanMarathonQR = () => {
    const qrCard = document.querySelector(".marathon-qr-card");
    qrCard?.scrollIntoView({ behavior: "smooth", block: "center" });
    setShareMessage("Open your mobile camera and point it at the QR code to register.");
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        setError(null);
      } catch (err) {
        console.error("Home data error:", err);
        setError(err.message || "Failed to load data");
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  /* =========================================================
COMPANY LOGOS
========================================================= */

  const companies = [
    { imgSrc: "/company/1a.png" },
    { imgSrc: "/company/1b.png" },
    { imgSrc: "/company/1c.png" },
    { imgSrc: "/company/1d.png" },
    { imgSrc: "/company/2.png" },
    { imgSrc: "/company/3.png" },
    { imgSrc: "/company/4.png" },
    { imgSrc: "/company/5.png" },
    { imgSrc: "/company/6.png" },
    { imgSrc: "/company/7.png" },
    { imgSrc: "/company/8.png" },
    { imgSrc: "/company/9.png" },
    { imgSrc: "/company/10.png" },
    { imgSrc: "/company/11.jpeg" },
    { imgSrc: "/company/12.jpeg" },
    { imgSrc: "/company/13.jpeg" },
  ];

  /* =========================================================
BANNERS
========================================================= */

  const banners = [
    { url: "/banner/banner21.jpeg" },
    { url: "/banner/banner22.jpeg" },
    { url: "/banner/banner23.jpeg" },
    { url: "/banner/dehk.jpeg" },
    { url: "/banner/dmek.png" },
    { url: "/banner/diagnosis1.png" },
    { url: "/banner/brs1.png" },
    { url: "/banner/brs2.png" },
    { url: "/banner/brs3.png" },
    { url: "/banner/brs4.jpeg" },
    // { url: "/banner5.png" },
  ];

  /* =========================================================
SLIDERS
========================================================= */

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    speed: 2000,
    pauseOnHover: false,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const settings2 = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const bannerSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
    adaptiveHeight: false,
  };

  /* =========================================================
FAQ
========================================================= */

  const faqs = [
    {
      q: "What is LifeOnPlus?",
      a: "LifeOnPlus is a complete digital healthcare ecosystem offering medical products, diagnostics, wellness services, and smart health technology.",
    },
    {
      q: "How does the Global Digital Health Smart Card work?",
      a: "It stores your medical records digitally. Doctors can scan the QR code to access your health history instantly during emergencies.",
    },
    {
      q: "What services can I access on LifeOnPlus?",
      a: "Health products, lab tests, doctor consultations, wellness therapies, insurance, and digital health tools — all in one place.",
    },
    {
      q: "Is my health data secure?",
      a: "We use strong security practices to help protect your personal health information.",
    },
    {
      q: "Can I become a partner or franchise?",
      a: "Yes. We offer channel partner, virtual partner, and franchise opportunities across India and globally.",
    },
    {
      q: "Do you offer home services?",
      a: "Yes. Many diagnostic tests, wellness therapies, and consultations are available with home collection or doorstep delivery.",
    },
  ];

  /* =========================================================
TESTIMONIALS
========================================================= */

  const testimonials = [
    {
      profession: "Tamil Actor",
      name: "Sharath Kumar",
      imgSrc: "/testimonials/user-1.jpeg",
      detail: "Innovative Product",
    },
    {
      profession: "Member of Lok Sabha",
      name: "Annasaheb Shankar Jolle",
      imgSrc: "/testimonials/user-2.jpeg",
      detail:
        "Highly advanced Medical & Digital Health Technology, I have seen the demo & appreciated, getting aligned with this company",
    },
    {
      profession:
        "BBM - Founder & Chairman of United Medicare Pte Ltd, Singapore",
      name: "Robin NG",
      imgSrc: "/testimonials/user-3.jpeg",
      detail: "Very Good Medical Technology and Devices",
    },
    {
      profession: "Former Education Minister",
      name: "Suresh Kumar",
      imgSrc: "/testimonials/user-4.jpeg",
      detail: "Excellent Medical Health Technology",
    },
    {
      profession: "Actress, Bangalore",
      name: "Ragini Dwivedi",
      imgSrc: "/testimonials/user-5.jpeg",
      detail:
        "Having spent many years on research and development on innovative medical technology. Finally we got a very good product for human beings. I wish Mr. Rajanikanth and his team great success.",
    },
    {
      profession: "National University of Singapore",
      name: "Cynthia Chan",
      imgSrc: "/testimonials/user-6.jpeg",
      detail: "New Medical & Innovative Idea",
    },
  ];

  /* =========================================================
SERVICES
========================================================= */

  const services = [
    {
      title: "Digital Emergency Health Kit",
      desc: "Instant access to medical records & emergency support anywhere",
      img: "/services-images/dehk.jpeg",
      link: "/services/1",
    },
    {
      title: "Digital & Medical Emergency Kit",
      desc: "Advanced health monitoring with real-time alerts and SOS",
      img: "/services-images/dmek.png",
      link: "/services/15",
    },
    {
      title: "Diagnosis Services",
      desc: "Accurate medical testing with instant digital reports",
      img: "/services-images/diagnosis1.jpeg",
      link: "/services/4",
    },
    {
      title: "Quick Health Checkup",
      desc: "Comprehensive body health assessment in minutes",
      img: "/services-images/qhc1.jpeg",
      link: "/services/14",
    },
    {
      title: "Express Medical Test",
      desc: "Fast & reliable diagnostic services at your convenience",
      img: "/services-images/emt2.png",
      link: "/services/3",
    },
    {
      title: "Body Recharge Station",
      desc: "Advanced wellness and recovery solutions",
      img: "/services-images/brs1.jpeg",
      link: "/services/5",
    },
  ];

  /* =========================================================
MEMBERSHIP
========================================================= */

  const membershipPlans = [
    {
      name: "BASIC",
      price: "₹300",
      color: "#35A93E",
      light: "#effbf1",
    },
    {
      name: "BRONZE",
      price: "₹600",
      color: "#d97706",
      light: "#fff7ed",
    },
    {
      name: "BRONZE PLUS",
      price: "₹1,000",
      color: "#6b3a24",
      light: "#faf4f0",
    },
    {
      name: "SILVER",
      price: "₹1,500",
      color: "#64748b",
      light: "#f8fafc",
    },
  ];

  /* =========================================================
ROLES
========================================================= */

  const roles = [
    {
      title: "Member",
      icon: <FaUsers />,
      desc: "Purchase healthcare products, manage memberships, and access exclusive member benefits.",
      color: "#02BE0F",
      bg: "#e9f9ee",
    },
    {
      title: "Channel Partner",
      icon: <FaHandshake />,
      desc: "Expand your business by promoting LifeOnPlus products and earning attractive commissions.",
      color: "#0d6efd",
      bg: "#e7f1ff",
    },
    {
      title: "Franchise",
      icon: <FaStoreAlt />,
      desc: "Own and operate a LifeOnPlus franchise while delivering healthcare services locally.",
      color: "#8b5cf6",
      bg: "#f3e8ff",
    },
    {
      title: "Channel Partner Plus",
      icon: <FaUserTie />,
      desc: "Unlock premium partnership benefits with higher rewards, incentives, and business revenue sharing.",
      color: "#ff9800",
      bg: "#fff4e5",
    },
    {
      title: "Corporate",
      icon: <FaBuilding />,
      desc: "Corporate employee wellness solutions for businesses, industries, and professionals.",
      color: "#6f42c1",
      bg: "#f3e8ff",
    },
    {
      title: "Director",
      icon: <FaBriefcase />,
      desc: "Manage partner networks, oversee operations, and drive regional business growth.",
      color: "#343a40",
      bg: "#f5f5f5",
    },
    {
      title: "Vendor",
      icon: <FaStore />,
      desc: "Sell healthcare products through our marketplace and manage your online business.",
      color: "#20c997",
      bg: "#e6fffa",
    },
    {
      title: "End User",
      icon: <FaUser />,
      desc: "Explore healthcare products, wellness services, and digital health solutions with ease.",
      color: "#6c757d",
      bg: "#f8f9fa",
    },
  ];

  /* =========================================================
MOUSE 3D EFFECT
========================================================= */

  const handle3DMove = (e) => {
    const card = e.currentTarget;
    const rect = card.getBoundingClientRect();

    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const rotateY = (x / rect.width - 0.5) * 10;
    const rotateX = (y / rect.height - 0.5) * -10;

    card.style.setProperty("--rotateX", `${rotateX}deg`);
    card.style.setProperty("--rotateY", `${rotateY}deg`);

    card.style.setProperty("--mouseX", `${(x / rect.width) * 100}%`);

    card.style.setProperty("--mouseY", `${(y / rect.height) * 100}%`);
  };

  const reset3D = (e) => {
    e.currentTarget.style.setProperty("--rotateX", "0deg");
    e.currentTarget.style.setProperty("--rotateY", "0deg");
    e.currentTarget.style.setProperty("--mouseX", "50%");
    e.currentTarget.style.setProperty("--mouseY", "50%");
  };

  /* =========================================================
LOADING
========================================================= */

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="lop-loader">
          <div className="lop-loader-ring"></div>
          <div className="lop-loader-dot"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return <p className="text-center text-red-600 mt-10">Error: {error}</p>;
  }

  return (
    <div className="lop-home-page">
      <div className="lop-bg-orb lop-bg-orb-one"></div>
      <div className="lop-bg-orb lop-bg-orb-two"></div>
      <div className="lop-bg-orb lop-bg-orb-three"></div>

      {/* =====================================================
      BANNER
  ===================================================== */}

      <section className="lop-banner-section">
        <Slider {...bannerSettings}>
          {banners.map((banner, index) => (
            <div key={index} className="lop-banner-slide">
              <div className="lop-banner-frame">
                <div className="lop-banner-glow"></div>
                <img
                  src={banner.url}
                  alt={`LifeOnPlus banner ${index + 1}`}
                  className={`lop-banner-image ${
                    banner.url === "/banner/banner5.jpg"
                      ? "lop-banner5-image"
                      : ""
                  }`}
                />

                <div className="lop-banner-shine"></div>
              </div>
            </div>
          ))}
        </Slider>
      </section>
      
{/* MARATHON REGISTRATION SECTION */}
<section className="marathon-registration-section">
  <div className="marathon-registration-card">
    <div className="marathon-registration-content">
      <span className="marathon-registration-label">
        LIFEONPLUS MARATHON
      </span>

      <h2>Join the Marathon!</h2>

      <p>
        Be a part of the LifeOnPlus Marathon.
        Scan the QR code or click below to register.
      </p>

      <button
        type="button"
        className="marathon-register-button"
        onClick={() => window.open(MARATHON_REGISTRATION_URL, "_blank", "noopener,noreferrer")}
      >
        Register Now <span>→</span>
      </button>

      <div className="marathon-quick-actions" aria-label="Marathon sharing options">
        <button type="button" onClick={handleShareMarathonLink} aria-label="Share registration link" title="Share link"><FaShareAlt /> <span>Share</span></button>
        <button type="button" onClick={handleCopyMarathonLink} aria-label="Copy registration link" title="Copy link"><FaCopy /> <span>Copy Link</span></button>
        <button type="button" onClick={handleShareMarathonQR} aria-label="Share QR code" title="Share QR code"><FaQrcode /> <span>Share QR</span></button>
        <button type="button" onClick={handleScanMarathonQR} aria-label="View QR code to scan" title="View QR code"><FaCamera /> <span>Scan QR</span></button>
      </div>
      {shareMessage && (
        <p className="marathon-action-message" role="status">{shareMessage}</p>
      )}
    </div>

    <div className="marathon-qr-card">
      <QRCodeCanvas
        value={MARATHON_REGISTRATION_URL}
        size={180}
        level="H"
        includeMargin={true}
        className="marathon-registration-qr"
      />

      <h3>Scan to Register</h3>
      <p>Scan this QR code with your mobile camera.</p>
    </div>
  </div>
</section>


      {/* =====================================================
      TRUST BAR
  ===================================================== */}

      <section className="lop-trust-section">
        <div className="max-w-7xl mx-auto px-4">
          <div className="lop-trust-grid">
            <div className="lop-trust-item">
              <div className="lop-trust-icon">
                <FaShieldAlt />
              </div>

              <div>
                <strong>100% Secure Payment</strong>
                <span>Safe & protected</span>
              </div>
            </div>

            <div className="lop-trust-item">
              <div className="lop-trust-icon">
                <FaAward />
              </div>

              <div>
                <strong>ISO Certified</strong>
                <span>Trusted healthcare</span>
              </div>
            </div>

            <div className="lop-trust-item">
              <div className="lop-trust-icon">
                <FaUsers />
              </div>

              <div>
                <strong>10,000+ Happy Customers</strong>
                <span>Growing community</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
      COMPANY LOGOS
  ===================================================== */}

      <section className="lop-section lop-company-section">
        <div className="max-w-7xl mx-auto px-4">
          <div className="lop-section-heading-small">
            Trusted Healthcare Network
          </div>

          <Slider {...settings}>
            {companies.map((item, index) => (
              <div key={index} className="lop-company-slide">
                <div className="lop-company-card">
                  <div className="lop-company-card-inner">
                    <img
                      src={item.imgSrc}
                      alt="LifeOnPlus company"
                      className="lop-company-logo"
                    />
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>

      {/* =====================================================
      ABOUT LIFEONPLUS
  ===================================================== */}

      <section className="lop-section lop-about-section">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="lop-reveal-content">
              <span className="lop-eyebrow">DIGITAL HEALTHCARE ECOSYSTEM</span>

              <h2 className="text-4xl font-bold mb-6 lop-gradient-heading">
                About LifeOnPlus
              </h2>

              <p className="text-gray-600 leading-relaxed text-lg">
                We are pioneers in Digital Health Technology, combining
                innovative medical devices with advanced digital solutions to
                make healthcare accessible, affordable, and intelligent for
                everyone.
              </p>

              <div className="mt-8 grid grid-cols-3 gap-6">
                <div className="lop-stat-card">
                  <div className="lop-stat-number">10+</div>
                  <div className="lop-stat-label">Verticals</div>
                </div>

                <div className="lop-stat-card">
                  <div className="lop-stat-number">6</div>
                  <div className="lop-stat-label">Countries</div>
                </div>

                <div className="lop-stat-card">
                  <div className="lop-stat-number">30+</div>
                  <div className="lop-stat-label">Partners</div>
                </div>
              </div>
            </div>

            <div
              className="lop-about-3d"
              onMouseMove={handle3DMove}
              onMouseLeave={reset3D}
            >
              <div className="lop-card-depth"></div>

              <div className="lop-about-image-frame">
                <img
                  src="/banner24.jpeg"
                  alt="About LifeOnPlus"
                  className="lop-about-image"
                />

                <div className="lop-image-shine"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
      WHY CHOOSE LIFEONPLUS
  ===================================================== */}

      <section className="lop-section lop-why-section">
        <div className="max-w-7xl mx-auto px-4">
          <div className="lop-heading-center">
            <span className="lop-eyebrow">WHY LIFEONPLUS</span>

            <h2 className="text-4xl font-bold lop-gradient-heading">
              Why Choose LifeOnPlus?
            </h2>

            <p className="text-gray-600 mt-3">
              Smart technology designed around your healthcare needs.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mt-12">
            {[
              {
                icon: <FaGlobe size={42} />,
                title: "Global Standards",
                desc: "ISO certified & HIPAA compliant technology",
              },
              {
                icon: <FaBatteryFull size={42} />,
                title: "Advanced Technology",
                desc: "Latest medical devices with digital integration",
              },
              {
                icon: <FaShieldAlt size={42} />,
                title: "Secure & Reliable",
                desc: "Your health data is protected with strong security",
              },
              {
                icon: <FaUsers size={42} />,
                title: "Expert Support",
                desc: "24/7 dedicated customer care & technical support",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="lop-3d-card lop-feature-card"
                onMouseMove={handle3DMove}
                onMouseLeave={reset3D}
              >
                <div className="lop-card-glow"></div>
                <div className="lop-card-shine"></div>

                <div className="lop-feature-icon">{item.icon}</div>

                <h3>{item.title}</h3>

                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =====================================================
      MEMBERSHIP
  ===================================================== */}

      <section className="lop-section lop-membership-section">
        <div className="max-w-6xl mx-auto px-4">
          <div className="lop-heading-center">
            <span className="lop-eyebrow">MEMBERSHIP PLANS</span>

            <h2 className="text-3xl sm:text-4xl font-extrabold">
              Choose Your Membership
            </h2>

            <p className="text-gray-500 mt-2">
              Select a membership plan and get started with LifeOnPlus.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-10">
            {membershipPlans.map((plan, index) => (
              <div
                key={index}
                className="lop-3d-card lop-membership-card"
                onMouseMove={handle3DMove}
                onMouseLeave={reset3D}
              >
                <div
                  className="lop-membership-top"
                  style={{
                    backgroundColor: plan.color,
                  }}
                />

                <div
                  className="lop-membership-glow"
                  style={{
                    backgroundColor: plan.color,
                  }}
                />

                <div className="lop-membership-content">
                  <div
                    className="lop-membership-number"
                    style={{
                      color: plan.color,
                      backgroundColor: plan.light,
                    }}
                  >
                    {index + 1}
                  </div>

                  <h3>{plan.name}</h3>

                  <div
                    className="lop-membership-price"
                    style={{
                      color: plan.color,
                    }}
                  >
                    {plan.price}
                  </div>

                  <button
                    type="button"
                    className="lop-premium-button"
                    style={{
                      backgroundColor: plan.color,
                    }}
                    onClick={() => {
                      window.location.href = "/signup/member";
                    }}
                  >
                    Get Started
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* =================================================
          BENEFIT COMPARISON
      ================================================= */}

          <div className="lop-benefit-wrapper mt-8">
            <div className="lop-benefit-title">BENEFITS COMPARISON</div>

            <div className="overflow-x-auto">
              <table className="lop-benefit-table">
                <thead>
                  <tr>
                    <th>BENEFITS</th>

                    {membershipPlans.map((plan) => (
                      <th key={plan.name}>
                        <span style={{ color: plan.color }}>{plan.name}</span>

                        <small>{plan.price}</small>
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td colSpan="5" className="lop-table-heading">
                      DIGITAL HEALTH IDENTITY
                    </td>
                  </tr>

                  {[
                    "Digital Emergency Health Kit",
                    "Digital Card with Photo ID",
                    "NFC Card with Photo ID",
                    "ABHA - National Health Authority",
                  ].map((item) => (
                    <tr key={item}>
                      <td>{item}</td>
                      <td>✓</td>
                      <td>✓</td>
                      <td>✓</td>
                      <td>✓</td>
                    </tr>
                  ))}

                  <tr>
                    <td colSpan="5" className="lop-table-heading blue">
                      ONE TOUCH - SERVICES
                    </td>
                  </tr>

                  {[
                    ["Emergency Health Report Button", "5", "10", "15", "30"],
                    ["Rescue Button (GPS/SMS/Call)", "5", "10", "15", "30"],
                    [
                      "Emergency Health Button (GPS/SMS/Call)",
                      "5",
                      "10",
                      "15",
                      "30",
                    ],
                    [
                      "GPS Live Tracking Ambulance Button",
                      "5",
                      "10",
                      "15",
                      "30",
                    ],
                    ["One Touch Police", "5", "10", "15", "30"],
                    ["One Touch Fire", "5", "10", "15", "30"],
                    [
                      "One Touch - Smart Reminder",
                      "Unlimited",
                      "Unlimited",
                      "Unlimited",
                      "Unlimited",
                    ],
                    [
                      "One Touch - Dr. Consultation",
                      "✕",
                      "✕",
                      "One Time",
                      "Two Times",
                    ],
                  ].map((row, index) => (
                    <tr key={index}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex}>{cell}</td>
                      ))}
                    </tr>
                  ))}

                  <tr>
                    <td colSpan="5" className="lop-table-heading blue">
                      COMPLIMENTARY MEDICAL TESTS
                    </td>
                  </tr>

                  <tr>
                    <td colSpan="5" className="lop-table-subheading">
                      INVASIVE - NABL - APPROVED LABS
                    </td>
                  </tr>

                  {[
                    ["CBC", "One Time", "One Time", "Two Times", "Two Times"],
                    [
                      "Lipid profile or any alternative tests",
                      "✕",
                      "✕",
                      "✕",
                      "One Time",
                    ],
                  ].map((row, index) => (
                    <tr key={index}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex}>{cell}</td>
                      ))}
                    </tr>
                  ))}

                  <tr>
                    <td colSpan="5" className="lop-table-subheading">
                      NON INVASIVE
                    </td>
                  </tr>

                  {[
                    [
                      "Heart Health (Artery Blockage)",
                      "✕",
                      "One Time",
                      "One Time",
                      "One Time",
                    ],
                    ["Advanced ECG", "✕", "One Time", "One Time", "One Time"],
                    [
                      "Antioxidant Measurement Test",
                      "✕",
                      "One Time",
                      "One Time",
                      "Two Times",
                    ],
                  ].map((row, index) => (
                    <tr key={index}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex}>{cell}</td>
                      ))}
                    </tr>
                  ))}

                  <tr>
                    <td colSpan="5" className="lop-table-heading red">
                      AI (CONTACTLESS) COMING SOON
                    </td>
                  </tr>

                  {[
                    [
                      "6 Tests - 30 Plus",
                      "6 Tests",
                      "6 Tests",
                      "6 Tests",
                      "6 Tests",
                    ],
                    [
                      "Dedicated Tests from NABL-Labs",
                      "✕",
                      "✕",
                      "2 Tests",
                      "6 Tests",
                    ],
                  ].map((row, index) => (
                    <tr key={index}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex}>{cell}</td>
                      ))}
                    </tr>
                  ))}

                  <tr>
                    <td colSpan="5" className="lop-table-heading">
                      OTHER BENEFITS
                    </td>
                  </tr>

                  <tr>
                    <td>Renewal Yearly</td>

                    <td>✓</td>
                    <td>✓</td>
                    <td>✓</td>
                    <td>✓</td>
                  </tr>

                  <tr>
                    <td colSpan="5" className="lop-table-heading dark">
                      VALUE ADDED SERVICES & DISCOUNTS %
                    </td>
                  </tr>

                  {[
                    [
                      "App / Web - based Products / Services",
                      "10% OFF",
                      "15% OFF",
                      "20% OFF",
                      "25% OFF",
                    ],
                    ["Labs Test", "10% OFF", "15% OFF", "20% OFF", "25% OFF"],
                    [
                      "Hospital Test",
                      "10% OFF",
                      "15% OFF",
                      "20% OFF",
                      "25% OFF",
                    ],
                    [
                      "Digital Health Studio - Services",
                      "10% OFF",
                      "15% OFF",
                      "20% OFF",
                      "25% OFF",
                    ],
                  ].map((row, index) => (
                    <tr key={index}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex}>{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="lop-benefit-bottom">
              <div className="lop-benefit-bottom-title">
                ONE MEMBERSHIP – MANY BENEFITS
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-10 gap-3 mt-5">
                {[
                  ["💊", "Digital Emergency Health Kit"],
                  ["💳", "Digital & NFC Health Card"],
                  ["🏥", "ABHA Integrated"],
                  ["🚨", "One Touch Emergency Services"],
                  ["🚑", "GPS Ambulance Live Tracking"],
                  ["🛡️", "Police & Fire Assistance"],
                  ["👨‍⚕️", "Doctor Consultation"],
                  ["❤️", "Preventive Health Tests"],
                  ["🔬", "NABL Approved Lab Tests"],
                  ["🤖", "AI Contactless Technology"],
                ].map(([icon, title], index) => (
                  <div
                    key={index}
                    className="lop-mini-benefit"
                    onMouseMove={handle3DMove}
                    onMouseLeave={reset3D}
                  >
                    <div className="lop-mini-benefit-icon">{icon}</div>

                    <p>{title}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
      AI HEALTHCARE
  ===================================================== */}

      <section className="lop-section lop-ai-section">
        <div className="max-w-7xl mx-auto px-4">
          <div className="lop-heading-center">
            <span className="lop-coming-badge-main">🚀 Launching Soon</span>

            <h2 className="text-3xl md:text-4xl font-bold mt-4">
              AI-Powered Healthcare Services
            </h2>

            <p className="text-gray-600 mt-3 max-w-3xl mx-auto">
              We're introducing intelligent AI healthcare solutions to help
              members receive faster guidance, smarter recommendations, and
              enhanced digital healthcare experiences.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center mt-12">
            <div className="space-y-5">
              {[
                {
                  icon: "🤖",
                  title: "AI Healthcare Assistant",
                  desc: "Website & WhatsApp chatbot providing 24×7 health-related assistance.",
                },
                {
                  icon: "📋",
                  title: "AI Prescription Assistant",
                  desc: "AI-assisted prescription suggestions based on symptoms and medical history.",
                },
                {
                  icon: "🧠",
                  title: "AI Health Recommendations",
                  desc: "Personalized health insights, wellness guidance, and preventive care recommendations.",
                },
                {
                  icon: "🩺",
                  title: "AI Body Screening",
                  desc: "AI-powered body screening with analysis of multiple vital health parameters for early health insights.",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="lop-ai-item"
                  onMouseMove={handle3DMove}
                  onMouseLeave={reset3D}
                >
                  <div className="lop-ai-icon">{item.icon}</div>

                  <div>
                    <h4>{item.title}</h4>

                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div
              className="lop-ai-image-card"
              onMouseMove={handle3DMove}
              onMouseLeave={reset3D}
            >
              <img
                src="/ai-healthcare-coming-soon.png"
                alt="AI Healthcare Services"
              />

              <div className="lop-ai-floating-badge">AI POWERED</div>

              <div className="lop-image-shine"></div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
      HOW LIFEONPLUS WORKS
  ===================================================== */}

      <section className="lop-section lop-how-section">
        <div className="max-w-7xl mx-auto px-4">
          <div className="lop-heading-center">
            <span className="lop-eyebrow">SIMPLE & SMART</span>

            <h2 className="text-4xl font-bold">How LifeOnPlus Works</h2>

            <p className="text-gray-600 mt-3">
              Get started in just a few simple steps.
            </p>
          </div>

          <div className="grid md:grid-cols-5 gap-6 mt-12">
            {[
              ["01", "Register", "Create your LifeOnPlus account."],
              [
                "02",
                "Complete Profile",
                "Add your healthcare information securely.",
              ],
              ["03", "Choose Membership", "Select a suitable healthcare plan."],
              ["04", "Access Services", "Book healthcare services anytime."],
              ["05", "Stay Healthy", "Track and manage your digital health."],
            ].map(([number, title, desc], index) => (
              <div
                key={index}
                className="lop-step-card"
                onMouseMove={handle3DMove}
                onMouseLeave={reset3D}
              >
                <div className="lop-step-number">{number}</div>

                <h3>{title}</h3>

                <p>{desc}</p>

                {index < 4 && <div className="lop-step-line"></div>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =====================================================
      ACCOUNT ACCESS
  ===================================================== */}

      <section className="lop-section lop-account-section">
        <div className="max-w-7xl mx-auto px-4">
          <div className="lop-heading-center">
            <span className="lop-eyebrow">GET STARTED</span>

            <h2 className="text-3xl md:text-4xl font-bold">
              Access Your LifeOnPlus Account
            </h2>

            <p className="text-gray-600 max-w-2xl mx-auto mt-3">
              Click the <strong>Account</strong> button in the top-right corner
              to register or log in as a Member, Partner, Corporate, Vendor,
              Franchise, Director, or End User.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-5 mt-10">
            {[
              {
                icon: <FaMousePointer />,
                title: "Click Account",
                desc: "Open the Account menu from the header.",
              },
              {
                icon: <FaUserCheck />,
                title: "Select Role",
                desc: "Choose your preferred account type.",
              },
              {
                icon: <FaSignInAlt />,
                title: "Register / Login",
                desc: "Complete registration or sign in.",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="lop-account-step"
                onMouseMove={handle3DMove}
                onMouseLeave={reset3D}
              >
                <div className="lop-account-step-icon">{item.icon}</div>

                <div>
                  <h3>{item.title}</h3>

                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-8">
            {roles.map((role, index) => (
              <div
                key={index}
                className="lop-role-card"
                onMouseMove={handle3DMove}
                onMouseLeave={reset3D}
              >
                <div
                  className="lop-role-icon"
                  style={{
                    backgroundColor: role.bg,
                    color: role.color,
                  }}
                >
                  {role.icon}
                </div>

                <h4>{role.title}</h4>

                <p>{role.desc}</p>

                <span className="lop-role-arrow">→</span>
              </div>
            ))}
          </div>

          <div className="text-center mt-10">
            <button onClick={openAccountModal} className="lop-main-button">
              Register / Login
              <span>→</span>
            </button>

            <p className="text-sm text-gray-500 mt-3">
              Opens the Account window where you can choose your role and
              continue.
            </p>
          </div>
        </div>
      </section>

      {/* =====================================================
      SERVICES
  ===================================================== */}

      <section className="lop-section lop-services-section">
        <div className="max-w-7xl mx-auto px-4">
          <div className="lop-heading-center">
            <span className="lop-eyebrow">HEALTHCARE SOLUTIONS</span>

            <h2 className="text-4xl font-bold">Our Popular Services</h2>

            <p className="text-gray-600 mt-3">
              Innovative health solutions for a better life
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
            {services.map((service, index) => (
              <div
                key={index}
                onClick={() => navigate(service.link)}
                className="lop-service-card"
                onMouseMove={handle3DMove}
                onMouseLeave={reset3D}
              >
                <div className="lop-service-image-box">
                  <img
                    src={service.img}
                    alt={service.title}
                    className="lop-service-image"
                  />

                  <div className="lop-service-image-glow"></div>

                  <div className="lop-image-shine"></div>
                </div>

                <div className="lop-service-content">
                  <span className="lop-service-number">0{index + 1}</span>

                  <h3>{service.title}</h3>

                  <p>{service.desc}</p>

                  <div className="lop-service-link">
                    Explore Now
                    <span>→</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="flex justify-center mt-10">
            <button
              onClick={() => navigate("/services")}
              className="lop-main-button"
            >
              Explore All Services
              <span>→</span>
            </button>
          </div>
        </div>
      </section>

      {/* =====================================================
      TESTIMONIAL
  ===================================================== */}

      <section className="lop-section lop-testimonial-section">
        <div className="max-w-7xl mx-auto px-4">
          <div className="lop-heading-center">
            <span className="lop-eyebrow">TRUSTED BY MANY</span>

            <h2 className="text-4xl font-bold">Testimonial</h2>

            <p className="text-gray-600 mt-3">
              What others say about lifeonplus.
            </p>
          </div>

          <div className="testimonial-slider mt-10">
            <Slider {...settings2}>
              {testimonials.map((item, index) => (
                <div key={index} className="px-3">
                  <div
                    className="lop-testimonial-card"
                    onMouseMove={handle3DMove}
                    onMouseLeave={reset3D}
                  >
                    <div className="lop-quote">"</div>

                    <div className="lop-testimonial-image-wrap">
                      <img
                        src={item.imgSrc}
                        alt={item.name}
                        className="lop-testimonial-image"
                      />
                    </div>

                    <p className="lop-testimonial-profession">
                      {item.profession}
                    </p>

                    <h3>{item.name}</h3>

                    <p className="lop-testimonial-detail">{item.detail}</p>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>

      {/* =====================================================
      FAQ
  ===================================================== */}

      <section className="lop-section lop-faq-section">
        <div className="max-w-7xl mx-auto px-4">
          <div className="lop-heading-center">
            <span className="lop-eyebrow">NEED HELP?</span>

            <h2 className="text-4xl font-bold">Frequently Asked Questions</h2>

            <p className="text-gray-600 mt-3">
              Quick answers to common questions
            </p>
          </div>

          <div className="max-w-4xl mx-auto mt-10 space-y-4">
            {faqs.map((faq, index) => (
              <details key={index} className="lop-faq-card">
                <summary>
                  <span>{faq.q}</span>

                  <span className="lop-faq-plus">+</span>
                </summary>

                <div className="lop-faq-answer">{faq.a}</div>
              </details>
            ))}
          </div>

          <div className="text-center mt-10">
            <button onClick={() => navigate("/faq")} className="lop-faq-button">
              View All FAQs →
            </button>
          </div>
        </div>
      </section>

      {/* =====================================================
      CONTACT CTA
  ===================================================== */}

      <section className="lop-contact-section">
        <div className="lop-contact-orb lop-contact-orb-one"></div>
        <div className="lop-contact-orb lop-contact-orb-two"></div>

        <div className="max-w-5xl mx-auto px-4 text-center relative z-10">
          <span className="lop-contact-label">LET'S CONNECT</span>

          <h2>Have Questions? Let's Talk.</h2>

          <p>
            Our team is here to help you with memberships, healthcare services,
            partnerships, and any questions about LifeOnPlus. We'd love to hear
            from you.
          </p>

          <button
            onClick={() => navigate("/contact")}
            className="lop-contact-button"
          >
            Contact Us
            <span>→</span>
          </button>
        </div>
      </section>

      {/* =====================================================
      VIDEO MODAL
  ===================================================== */}

      {selectedVideo && (
        <div className="lop-video-modal" onClick={() => setSelectedVideo(null)}>
          <div className="lop-video-box" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => setSelectedVideo(null)}
              className="lop-video-close"
            >
              ✕
            </button>

            <video src={selectedVideo} controls autoPlay />
          </div>
        </div>
      )}

      {/* =====================================================
      PREMIUM 3D CSS
  ===================================================== */}

      <style>{`

/* =========================================================
GLOBAL
========================================================= */

html,
body,
#root {
max-width: 100%;
overflow-x: hidden !important;
}

.lop-home-page {
position: relative;
width: 100%;
overflow: hidden;
background:
linear-gradient(
180deg,
#ffffff 0%,
#fbfefb 45%,
#ffffff 100%
);
isolation: isolate;
}

.lop-home-page * {
box-sizing: border-box;
}

.lop-section {
position: relative;
z-index: 2;
}

.lop-bg-orb {
position: absolute;
border-radius: 50%;
pointer-events: none;
z-index: -1;
filter: blur(5px);
}

.lop-bg-orb-one {
width: 360px;
height: 360px;
left: -180px;
top: 600px;
background: rgba(53,169,62,.055);
animation: lopOrbOne 11s ease-in-out infinite;
}

.lop-bg-orb-two {
width: 300px;
height: 300px;
right: -150px;
top: 1600px;
background: rgba(21,125,35,.045);
animation: lopOrbTwo 13s ease-in-out infinite;
}

.lop-bg-orb-three {
width: 250px;
height: 250px;
left: -100px;
top: 3500px;
background: rgba(53,169,62,.045);
animation: lopOrbThree 12s ease-in-out infinite;
}

@keyframes lopOrbOne {
0%,100% {
transform: translate3d(0,0,0);
}
50% {
transform: translate3d(50px,35px,0);
}
}

@keyframes lopOrbTwo {
0%,100% {
transform: translate3d(0,0,0);
}
50% {
transform: translate3d(-50px,-40px,0);
}
}

@keyframes lopOrbThree {
0%,100% {
transform: translate3d(0,0,0);
}
50% {
transform: translate3d(40px,-35px,0);
}
}

/* =========================================================
COMMON HEADINGS
========================================================= */

.lop-heading-center {
text-align: center;
}

.lop-eyebrow {
display: inline-flex;
align-items: center;
gap: 8px;
color: #35A93E;
font-size: 11px;
font-weight: 800;
letter-spacing: .16em;
text-transform: uppercase;
}

.lop-eyebrow::before,
.lop-eyebrow::after {
content: "";
width: 22px;
height: 2px;
border-radius: 10px;
background: #35A93E;
}

.lop-gradient-heading {
background:
linear-gradient(
100deg,
#16351D,
#35A93E,
#16351D
);
background-size: 200% auto;
-webkit-background-clip: text;
background-clip: text;
color: transparent;
animation: lopHeadingGradient 7s linear infinite;
}

@keyframes lopHeadingGradient {
0% {
background-position: 0% center;
}
100% {
background-position: 200% center;
}
}

/* =========================================================
LOADER
========================================================= */

.lop-loader {
width: 65px;
height: 65px;
position: relative;
}

.lop-loader-ring {
width: 100%;
height: 100%;
border: 4px solid #e7f6e9;
border-top-color: #35A93E;
border-right-color: #35A93E;
border-radius: 50%;
animation: lopLoaderSpin 1s linear infinite;
}

.lop-loader-dot {
width: 10px;
height: 10px;
position: absolute;
top: 50%;
left: 50%;
margin: -5px;
border-radius: 50%;
background: #35A93E;
box-shadow: 0 0 20px rgba(53,169,62,.5);
}

@keyframes lopLoaderSpin {
to {
transform: rotate(360deg);
}
}

/* =========================================================
BANNER
========================================================= */

.lop-banner-section {
width: 100%;
background: #fff;
overflow: hidden;
}

.lop-banner-slide {
padding: 0;
}

.lop-banner-frame {
position: relative;
width: 100%;
overflow: hidden;
background: #fff;
border-bottom: 1px solid rgba(53,169,62,.12);
}

.lop-banner-image {
  display: block;
  width: 100%;
  height: auto !important;
  max-height: none !important;
  object-fit: contain !important;
  transition:
    transform 1.1s cubic-bezier(.2,.8,.2,1),
    filter .8s ease;
}

.lop-banner-frame .lop-banner-image {
  transform: scale(1.012);
}

.lop-banner-glow {
position: absolute;
width: 220px;
height: 220px;
border-radius: 50%;
left: -100px;
top: -100px;
background: rgba(53,169,62,.10);
filter: blur(45px);
pointer-events: none;
z-index: 2;
}

.lop-banner-shine {
position: absolute;
inset: 0;
pointer-events: none;
z-index: 4;
background:
linear-gradient(
115deg,
transparent 35%,
rgba(255,255,255,.24) 48%,
transparent 60%
);
transform: translateX(-120%);
animation: lopBannerShine 7s ease-in-out infinite;
}

@keyframes lopBannerShine {
0%,60% {
transform: translateX(-120%);
}
75%,100% {
transform: translateX(120%);
}
}

/* =========================================================
TRUST
========================================================= */

.lop-trust-section {
position: relative;
background: rgba(255,255,255,.88);
backdrop-filter: blur(12px);
border-bottom: 1px solid rgba(0,0,0,.04);
border-top: 1px solid rgba(53,169,62,.05);
}

.lop-trust-grid {
display: grid;
grid-template-columns: repeat(3,1fr);
}

.lop-trust-item {
min-height: 74px;
display: flex;
align-items: center;
justify-content: center;
gap: 12px;
transition:
transform .4s ease,
background .4s ease;
}

.lop-trust-item {
transform: translateY(-3px);
background: rgba(53,169,62,.025);
}

.lop-trust-icon {
width: 42px;
height: 42px;
border-radius: 13px;
display: flex;
align-items: center;
justify-content: center;
color: #35A93E;
background: #effbf1;
font-size: 18px;
box-shadow:
0 6px 15px rgba(53,169,62,.10);
transition:
transform .4s ease,
box-shadow .4s ease;
}

.lop-trust-item .lop-trust-icon {
transform:
perspective(500px)
rotateY(15deg)
scale(1.08);
box-shadow:
0 12px 25px rgba(53,169,62,.18);
}

.lop-trust-item strong {
display: block;
font-size: 13px;
color: #202820;
}

.lop-trust-item span {
display: block;
font-size: 10px;
color: #888;
margin-top: 2px;
}

/* =========================================================
COMPANY
========================================================= */

.lop-company-section {
padding: 35px 0;
}

.lop-section-heading-small {
text-align: center;
color: #8a8a8a;
font-size: 10px;
letter-spacing: .18em;
text-transform: uppercase;
font-weight: 700;
margin-bottom: 15px;
}

.lop-company-slide {
padding: 10px;
}

.lop-company-card {
perspective: 900px;
}

.lop-company-card-inner {
height: 76px;
border-radius: 18px;
background:
linear-gradient(
145deg,
#ffffff,
#f8fbf8
);
border: 1px solid rgba(0,0,0,.055);
display: flex;
align-items: center;
justify-content: center;
padding: 10px;
box-shadow:
0 6px 18px rgba(0,0,0,.035);
transition:
transform .45s cubic-bezier(.2,.8,.2,1),
box-shadow .45s ease,
border-color .45s ease;
}

.lop-company-card-inner {
transform:
translateY(-7px)
rotateX(5deg)
rotateY(-4deg);
border-color: rgba(53,169,62,.25);
box-shadow:
0 20px 38px rgba(0,0,0,.08),
0 8px 20px rgba(53,169,62,.08);
}

.lop-company-logo {
width: auto;
max-width: 86%;
height: 48px;
object-fit: contain;
transition: transform .45s ease;
}

.lop-company-card-inner .lop-company-logo {
transform: scale(1.06);
}

/* =========================================================
ABOUT
========================================================= */

.lop-about-section {
padding: 75px 0;
}

.lop-stat-card {
text-align: center;
padding: 12px 5px;
border-radius: 16px;
transition:
transform .4s ease,
background .4s ease;
}

.lop-stat-card {
transform: translateY(-5px);
background: rgba(53,169,62,.035);
}

.lop-stat-number {
font-size: 30px;
line-height: 1;
font-weight: 800;
color: #35A93E;
}

.lop-stat-label {
font-size: 11px;
color: #777;
margin-top: 6px;
}

.lop-about-3d {
position: relative;
perspective: 1200px;
transform-style: preserve-3d;
transform:
perspective(1200px)
rotateX(var(--rotateX,0deg))
rotateY(var(--rotateY,0deg));
transition:
transform .18s ease-out;
}

.lop-about-image-frame {
position: relative;
overflow: hidden;
border-radius: 28px;
background: #fff;
border: 3px solid #35A93E;
box-shadow:
0 25px 60px rgba(0,0,0,.10),
0 8px 25px rgba(53,169,62,.10);
transform: translateZ(20px);
}

.lop-about-image {
display: block;
width: 100%;
height: auto;
max-height: 520px;
object-fit: contain;
transition: transform .8s cubic-bezier(.2,.8,.2,1);
}

.lop-about-3d .lop-about-image {
transform: scale(1.025);
}

.lop-card-depth {
position: absolute;
inset: 16px -12px -15px 12px;
border-radius: 28px;
background:
linear-gradient(
135deg,
rgba(53,169,62,.12),
rgba(53,169,62,.025)
);
transform: translateZ(-25px);
}

/* =========================================================
3D COMMON CARDS
========================================================= */

.lop-3d-card {
position: relative;
overflow: hidden;
transform-style: preserve-3d;
perspective: 1000px;
transform:
perspective(1000px)
rotateX(var(--rotateX,0deg))
rotateY(var(--rotateY,0deg))
translateZ(0);
transition:
transform .16s ease-out,
box-shadow .45s ease,
border-color .35s ease;
}

.lop-card-glow {
position: absolute;
width: 190px;
height: 190px;
border-radius: 50%;
left: var(--mouseX,50%);
top: var(--mouseY,50%);
transform: translate(-50%,-50%);
background: rgba(53,169,62,.10);
filter: blur(50px);
opacity: 0;
pointer-events: none;
transition: opacity .35s ease;
}

.lop-3d-card .lop-card-glow {
opacity: 1;
}

.lop-card-shine {
position: absolute;
inset: 0;
z-index: 5;
pointer-events: none;
background:
linear-gradient(
110deg,
transparent 20%,
rgba(255,255,255,.40) 48%,
transparent 65%
);
transform: translateX(-130%);
transition: transform .75s ease;
}

.lop-3d-card .lop-card-shine {
transform: translateX(130%);
}

/* =========================================================
WHY
========================================================= */

.lop-why-section {
padding: 75px 0;
background:
linear-gradient(
180deg,
#ffffff,
#f8fcf9
);
}

.lop-feature-card {
min-height: 250px;
padding: 34px 24px;
border-radius: 28px;
border: 1px solid rgba(53,169,62,.10);
background:
linear-gradient(
145deg,
rgba(255,255,255,.98),
rgba(248,252,249,.95)
);
box-shadow:
0 10px 25px rgba(0,0,0,.045);
}

.lop-feature-card {
box-shadow:
0 28px 60px rgba(0,0,0,.11),
0 8px 25px rgba(53,169,62,.10);
}

.lop-feature-icon {
width: 76px;
height: 76px;
margin: 0 auto 24px;
border-radius: 22px;
display: flex;
align-items: center;
justify-content: center;
color: #35A93E;
background:
linear-gradient(
145deg,
#effbf1,
#ffffff
);
box-shadow:
0 12px 25px rgba(53,169,62,.12),
inset 0 1px 0 rgba(255,255,255,.9);
transform: translateZ(30px);
transition:
transform .5s cubic-bezier(.2,.8,.2,1),
box-shadow .5s ease;
}

.lop-feature-card .lop-feature-icon {
transform:
translateZ(45px)
rotateY(12deg)
rotateX(4deg)
scale(1.08);
box-shadow:
0 18px 35px rgba(53,169,62,.18);
}

.lop-feature-card h3 {
font-size: 18px;
font-weight: 700;
color: #18221a;
margin-bottom: 10px;
transform: translateZ(20px);
}

.lop-feature-card p {
color: #6b7280;
font-size: 13px;
line-height: 1.7;
transform: translateZ(12px);
}

/* =========================================================
MEMBERSHIP - COMPACT
========================================================= */

.lop-membership-section {
padding: 42px 0 45px;
background:
radial-gradient(
circle at 20% 20%,
rgba(53,169,62,.05),
transparent 30%
),
#f8faf9;
}

.lop-membership-section .lop-heading-center {
margin-bottom: 0;
}

.lop-membership-section .lop-heading-center h2 {
margin-top: 5px;
margin-bottom: 0;
}

.lop-membership-section .lop-heading-center p {
margin-top: 5px !important;
}

/* Compact cards */
.lop-membership-section
.grid.grid-cols-1.sm:grid-cols-2.lg:grid-cols-4 {
gap: 12px !important;
margin-top: 22px !important;
}

.lop-membership-card {
height: 150px;
min-height: 150px;
border-radius: 18px;
background: #fff;
border: 1px solid rgba(0,0,0,.06);
box-shadow:
0 7px 20px rgba(0,0,0,.045);
}

.lop-membership-card {
box-shadow:
0 20px 40px rgba(0,0,0,.10);
}

.lop-membership-top {
height: 3px;
width: 100%;
position: relative;
z-index: 3;
}

.lop-membership-glow {
position: absolute;
width: 110px;
height: 110px;
border-radius: 50%;
right: -50px;
top: -50px;
opacity: .08;
filter: blur(15px);
}

.lop-membership-content {
position: relative;
z-index: 5;
height: calc(100% - 3px);
display: flex;
flex-direction: column;
align-items: center;
padding: 10px 12px;
}

.lop-membership-number {
width: 26px;
height: 26px;
border-radius: 8px;
display: flex;
align-items: center;
justify-content: center;
font-size: 10px;
font-weight: 800;
transform: translateZ(25px);
}

.lop-membership-content h3 {
margin-top: 5px;
font-size: 12px;
font-weight: 800;
color: #222;
transform: translateZ(20px);
}

.lop-membership-price {
margin-top: 5px;
font-size: 19px;
line-height: 1;
font-weight: 900;
transform: translateZ(30px);
}

.lop-premium-button {
position: relative;
overflow: hidden;
margin-top: auto;
width: 100%;
height: 28px;
border: none;
border-radius: 7px;
color: white;
font-size: 9px;
font-weight: 700;
cursor: pointer;
box-shadow:
0 5px 12px rgba(0,0,0,.10);
transition:
transform .3s ease,
box-shadow .3s ease;
}

.lop-premium-button::before {
content: "";
position: absolute;
top: 0;
left: -120%;
width: 60%;
height: 100%;
background: rgba(255,255,255,.30);
transform: skewX(-20deg);
transition: left .6s ease;
}

.lop-premium-button {
transform: translateY(-2px) scale(1.015);
box-shadow:
0 10px 20px rgba(0,0,0,.15);
}

.lop-premium-button:hover::before {
left: 140%;
}

/* Benefit table closer to membership cards */
.lop-benefit-wrapper {
margin-top: 22px !important;
background: white;
border-radius: 22px;
overflow: hidden;
border: 1px solid rgba(0,0,0,.06);
box-shadow:
0 12px 35px rgba(0,0,0,.06);
}

/* =========================================================
BENEFIT TABLE
========================================================= */

.lop-benefit-title {
background:
linear-gradient(
120deg,
#123b7a,
#1e568f,
#123b7a
);
background-size: 200% auto;
animation: lopBlueGradient 8s linear infinite;
color: white;
text-align: center;
padding: 14px;
font-size: 17px;
font-weight: 800;
}

@keyframes lopBlueGradient {
to {
background-position: 200% center;
}
}

.lop-benefit-table {
width: 100%;
min-width: 820px;
border-collapse: collapse;
font-size: 11px;
}

.lop-benefit-table th,
.lop-benefit-table td {
padding: 8px 7px;
border-bottom: 1px solid #edf0ed;
text-align: center;
transition: background .25s ease;
}

.lop-benefit-table th,
.lop-benefit-table td {
text-align: left;
}

.lop-benefit-table th {
background: #fafcfb;
font-weight: 800;
}

.lop-benefit-table th small {
display: block;
color: #777;
margin-top: 3px;
}

.lop-benefit-table tbody tr td {
background: rgba(53,169,62,.025);
}

.lop-benefit-table tbody tr td {
color: #35A93E;
font-weight: 700;
}

.lop-table-heading {
background: #effbf1 !important;
color: #35A93E !important;
font-weight: 800 !important;
text-align: left !important;
}

.lop-table-heading.blue {
background: #eff6ff !important;
color: #123b7a !important;
}

.lop-table-heading.red {
background: #fff1f1 !important;
color: #dc2626 !important;
}

.lop-table-heading.dark {
background: #123b7a !important;
color: white !important;
text-align: center !important;
}

.lop-table-subheading {
text-align: left !important;
font-weight: 800 !important;
color: #555 !important;
}

.lop-benefit-bottom {
padding: 20px;
border-top: 1px solid #edf0ed;
}

.lop-benefit-bottom-title {
background: #123b7a;
color: white;
border-radius: 10px;
padding: 10px;
text-align: center;
font-weight: 800;
}

.lop-mini-benefit {
min-height: 100px;
padding: 12px 8px;
border-radius: 14px;
border: 1px solid #e7ebe7;
background: white;
text-align: center;
transform:
perspective(700px)
rotateX(var(--rotateX,0deg))
rotateY(var(--rotateY,0deg));
transition:
transform .16s ease-out,
box-shadow .35s ease;
}

.lop-mini-benefit {
box-shadow:
0 14px 30px rgba(0,0,0,.09);
}

.lop-mini-benefit-icon {
width: 38px;
height: 38px;
margin: auto;
border-radius: 11px;
background: #f5f8f5;
display: flex;
align-items: center;
justify-content: center;
font-size: 18px;
transition: transform .4s ease;
}

.lop-mini-benefit .lop-mini-benefit-icon {
transform:
translateZ(20px)
scale(1.1)
rotateY(10deg);
}

.lop-mini-benefit p {
margin-top: 7px;
font-size: 10px;
line-height: 1.4;
font-weight: 600;
color: #555;
}

/* =========================================================
AI
========================================================= */

.lop-ai-section {
padding: 75px 0;
background:
radial-gradient(
circle at 90% 20%,
rgba(53,169,62,.06),
transparent 30%
),
#fff;
}

.lop-coming-badge-main {
display: inline-flex;
padding: 7px 15px;
border-radius: 30px;
background: #fff4e5;
color: #d97706;
font-size: 11px;
font-weight: 800;
box-shadow: 0 6px 18px rgba(217,119,6,.10);
}

.lop-ai-item {
position: relative;
display: flex;
gap: 16px;
padding: 15px;
border-radius: 18px;
background: rgba(255,255,255,.65);
border: 1px solid transparent;
transform:
perspective(800px)
rotateX(var(--rotateX,0deg))
rotateY(var(--rotateY,0deg));
transition:
transform .16s ease-out,
box-shadow .35s ease,
border-color .35s ease;
}

.lop-ai-item {
border-color: rgba(53,169,62,.12);
box-shadow:
0 14px 30px rgba(0,0,0,.06);
}

.lop-ai-icon {
flex-shrink: 0;
width: 52px;
height: 52px;
border-radius: 15px;
background: #effbf1;
display: flex;
align-items: center;
justify-content: center;
font-size: 24px;
box-shadow:
0 8px 18px rgba(53,169,62,.08);
transform: translateZ(25px);
}

.lop-ai-item h4 {
font-size: 17px;
font-weight: 700;
color: #202820;
}

.lop-ai-item p {
color: #666;
font-size: 13px;
line-height: 1.7;
margin-top: 4px;
}

.lop-ai-image-card {
position: relative;
overflow: hidden;
border-radius: 30px;
background: white;
border: 1px solid #e9eee9;
box-shadow:
0 25px 60px rgba(0,0,0,.10);
transform:
perspective(1100px)
rotateX(var(--rotateX,0deg))
rotateY(var(--rotateY,0deg));
transition:
transform .16s ease-out,
box-shadow .45s ease;
}

.lop-ai-image-card {
box-shadow:
0 35px 75px rgba(0,0,0,.14);
}

.lop-ai-image-card img {
display: block;
width: 100%;
height: auto;
object-fit: contain;
transition: transform .8s ease;
}

.lop-ai-image-card img {
transform: scale(1.025);
}

.lop-ai-floating-badge {
position: absolute;
right: 18px;
top: 18px;
z-index: 5;
padding: 8px 13px;
border-radius: 30px;
background: rgba(53,169,62,.94);
color: white;
font-size: 9px;
font-weight: 800;
letter-spacing: .08em;
box-shadow:
0 10px 25px rgba(53,169,62,.22);
animation: lopBadgeFloat 3s ease-in-out infinite;
}

@keyframes lopBadgeFloat {
0%,100% {
transform: translateY(0);
}
50% {
transform: translateY(-7px);
}
}

/* =========================================================
HOW IT WORKS
========================================================= */

.lop-how-section {
padding: 75px 0;
background: #f8fbf9;
}

.lop-step-card {
position: relative;
min-height: 190px;
padding: 25px 18px;
text-align: center;
background: white;
border: 1px solid #e9eee9;
border-radius: 22px;
box-shadow: 0 8px 20px rgba(0,0,0,.035);
transform:
perspective(900px)
rotateX(var(--rotateX,0deg))
rotateY(var(--rotateY,0deg));
transition:
transform .16s ease-out,
box-shadow .4s ease;
}

.lop-step-card {
box-shadow:
0 25px 45px rgba(0,0,0,.10);
}

.lop-step-number {
width: 54px;
height: 54px;
margin: auto;
border-radius: 17px;
background:
linear-gradient(
145deg,
#35A93E,
#188b25
);
color: white;
display: flex;
align-items: center;
justify-content: center;
font-size: 16px;
font-weight: 900;
box-shadow:
0 12px 25px rgba(53,169,62,.22);
transform: translateZ(35px);
}

.lop-step-card h3 {
margin-top: 18px;
font-size: 15px;
font-weight: 800;
color: #202820;
}

.lop-step-card p {
margin-top: 7px;
font-size: 11px;
color: #777;
line-height: 1.6;
}

.lop-step-line {
position: absolute;
top: 51px;
right: -35px;
width: 35px;
height: 2px;
background:
linear-gradient(
90deg,
#35A93E,
transparent
);
}

/* =========================================================
ACCOUNT
========================================================= */

.lop-account-section {
padding: 75px 0;
}

.lop-account-step {
display: flex;
align-items: flex-start;
gap: 15px;
padding: 20px;
border-radius: 20px;
background: white;
border: 1px solid #e8ece8;
box-shadow: 0 7px 20px rgba(0,0,0,.035);
transform:
perspective(900px)
rotateX(var(--rotateX,0deg))
rotateY(var(--rotateY,0deg));
transition:
transform .16s ease-out,
box-shadow .4s ease;
}

.lop-account-step {
box-shadow:
0 20px 40px rgba(0,0,0,.09);
}

.lop-account-step-icon {
flex-shrink: 0;
width: 44px;
height: 44px;
border-radius: 14px;
display: flex;
align-items: center;
justify-content: center;
background: #effbf1;
color: #35A93E;
font-size: 18px;
box-shadow:
0 8px 18px rgba(53,169,62,.10);
transform: translateZ(25px);
}

.lop-account-step h3 {
font-size: 15px;
font-weight: 700;
}

.lop-account-step p {
margin-top: 5px;
color: #777;
font-size: 12px;
line-height: 1.5;
}

.lop-role-card {
position: relative;
overflow: hidden;
padding: 23px;
min-height: 190px;
border-radius: 22px;
background: white;
border: 1px solid #e7ebe7;
box-shadow: 0 8px 22px rgba(0,0,0,.04);
transform:
perspective(900px)
rotateX(var(--rotateX,0deg))
rotateY(var(--rotateY,0deg));
transition:
transform .16s ease-out,
box-shadow .4s ease,
border-color .35s ease;
}

.lop-role-card::before {
content: "";
position: absolute;
width: 140px;
height: 140px;
right: -70px;
top: -70px;
border-radius: 50%;
background: rgba(53,169,62,.045);
transition: transform .5s ease;
}

.lop-role-card {
box-shadow:
0 25px 50px rgba(0,0,0,.10);
border-color: rgba(53,169,62,.18);
}

.lop-role-card:hover::before {
transform: scale(1.5);
}

.lop-role-icon {
width: 48px;
height: 48px;
border-radius: 15px;
display: flex;
align-items: center;
justify-content: center;
font-size: 20px;
transform: translateZ(30px);
transition:
transform .45s ease,
box-shadow .45s ease;
}

.lop-role-card .lop-role-icon {
transform:
translateZ(45px)
rotateY(12deg)
scale(1.08);
box-shadow:
0 12px 25px rgba(0,0,0,.08);
}

.lop-role-card h4 {
position: relative;
z-index: 2;
margin-top: 14px;
font-size: 15px;
font-weight: 800;
color: #222;
transform: translateZ(20px);
}

.lop-role-card p {
position: relative;
z-index: 2;
margin-top: 7px;
font-size: 11px;
line-height: 1.65;
color: #777;
transform: translateZ(12px);
}

.lop-role-arrow {
position: absolute;
right: 18px;
bottom: 15px;
color: #35A93E;
font-weight: 800;
opacity: 0;
transform: translateX(-10px);
transition:
opacity .3s ease,
transform .3s ease;
}

.lop-role-card .lop-role-arrow {
opacity: 1;
transform: translateX(0);
}

.lop-main-button {
position: relative;
overflow: hidden;
border: none;
background:
linear-gradient(
120deg,
#35A93E,
#1e8d2b,
#35A93E
);
background-size: 200% auto;
color: white;
padding: 13px 27px;
border-radius: 12px;
font-weight: 700;
font-size: 13px;
box-shadow:
0 10px 25px rgba(53,169,62,.20);
transition:
transform .35s ease,
box-shadow .35s ease,
background-position .5s ease;
}

.lop-main-button {
transform:
translateY(-4px)
scale(1.02);
box-shadow:
0 18px 35px rgba(53,169,62,.25);
background-position: 100% center;
}

.lop-main-button span {
margin-left: 8px;
}

/* =========================================================
SERVICES
========================================================= */

.lop-services-section {
padding: 75px 0;
background:
linear-gradient(
180deg,
#ffffff,
#f8fbf9
);
}

.lop-service-card {
position: relative;
overflow: hidden;
border-radius: 28px;
background: white;
border: 1px solid #e8ece8;
box-shadow:
0 10px 25px rgba(0,0,0,.045);
cursor: pointer;
transform:
perspective(1000px)
rotateX(var(--rotateX,0deg))
rotateY(var(--rotateY,0deg));
transition:
transform .16s ease-out,
box-shadow .45s ease,
border-color .35s ease;
}

.lop-service-card {
box-shadow:
0 30px 60px rgba(0,0,0,.12),
0 10px 25px rgba(53,169,62,.07);
border-color: rgba(53,169,62,.20);
}

.lop-service-image-box {
height: 245px;
position: relative;
overflow: hidden;
background:
radial-gradient(
circle at center,
#ffffff,
#f2f5f2
);
}

.lop-service-image {
position: absolute;
inset: 0;
width: 100%;
height: 100%;
object-fit: contain !important;
padding: 10px;
transition:
transform .8s cubic-bezier(.2,.8,.2,1),
filter .5s ease;
}

.lop-service-card .lop-service-image {
transform: scale(1.075);
filter: saturate(1.05);
}

.lop-service-image-glow {
position: absolute;
width: 150px;
height: 150px;
border-radius: 50%;
left: 50%;
top: 50%;
transform: translate(-50%,-50%);
background: rgba(53,169,62,.07);
filter: blur(30px);
pointer-events: none;
}

.lop-service-content {
position: relative;
padding: 20px;
background: white;
z-index: 3;
}

.lop-service-number {
display: inline-flex;
color: #35A93E;
font-size: 10px;
font-weight: 800;
letter-spacing: .12em;
}

.lop-service-content h3 {
margin-top: 6px;
font-size: 19px;
font-weight: 800;
color: #202820;
}

.lop-service-content p {
margin-top: 7px;
font-size: 12px;
color: #777;
line-height: 1.65;
}

.lop-service-link {
display: flex;
align-items: center;
gap: 7px;
margin-top: 13px;
color: #35A93E;
font-size: 12px;
font-weight: 800;
transition: gap .3s ease;
}

.lop-service-card .lop-service-link {
gap: 13px;
}

/* =========================================================
TESTIMONIAL
========================================================= */

.lop-testimonial-section {
padding: 70px 0;
background:
linear-gradient(
135deg,
#fffaf5,
#fff5ec
);
}

.lop-testimonial-card {
position: relative;
overflow: hidden;
min-height: 335px;
margin: 10px 0 25px;
padding: 30px 22px;
text-align: center;
border-radius: 26px;
background:
linear-gradient(
145deg,
#ffffff,
#fffdfb
);
border: 1px solid rgba(0,0,0,.055);
box-shadow:
0 10px 25px rgba(0,0,0,.05);
transform:
perspective(950px)
rotateX(var(--rotateX,0deg))
rotateY(var(--rotateY,0deg));
transition:
transform .16s ease-out,
box-shadow .45s ease;
}

.lop-testimonial-card {
box-shadow:
0 28px 55px rgba(0,0,0,.12);
}

.lop-quote {
position: absolute;
top: 8px;
right: 20px;
font-size: 65px;
line-height: 1;
color: rgba(53,169,62,.07);
font-family: Georgia, serif;
}

.lop-testimonial-image-wrap {
position: relative;
width: 100px;
height: 100px;
margin: auto;
border-radius: 50%;
padding: 5px;
background:
linear-gradient(
135deg,
#35A93E,
#a5e8ab,
#35A93E
);
box-shadow:
0 12px 30px rgba(53,169,62,.15);
transform: translateZ(35px);
}

.lop-testimonial-image {
width: 100%;
height: 100%;
border-radius: 50%;
object-fit: contain;
background: white;
}

.lop-testimonial-profession {
margin-top: 18px;
font-size: 10px;
color: #999;
}

.lop-testimonial-card h3 {
margin-top: 4px;
font-size: 15px;
font-weight: 800;
color: #222;
}

.lop-testimonial-detail {
margin-top: 13px;
color: #666;
font-size: 11px;
line-height: 1.7;
}

/* =========================================================
FAQ
========================================================= */

.lop-faq-section {
padding: 75px 0;
}

.lop-faq-card {
overflow: hidden;
border: 1px solid #e6ebe6;
border-radius: 18px;
background: white;
box-shadow:
0 5px 18px rgba(0,0,0,.025);
transition:
transform .35s ease,
box-shadow .35s ease,
border-color .35s ease;
}

.lop-faq-card {
transform: translateY(-3px);
border-color: rgba(53,169,62,.20);
box-shadow:
0 15px 30px rgba(0,0,0,.06);
}

.lop-faq-card summary {
list-style: none;
cursor: pointer;
padding: 19px 22px;
display: flex;
align-items: center;
justify-content: space-between;
gap: 15px;
font-size: 14px;
font-weight: 700;
color: #222;
}

.lop-faq-card summary::-webkit-details-marker {
display: none;
}

.lop-faq-plus {
flex-shrink: 0;
width: 28px;
height: 28px;
border-radius: 9px;
display: flex;
align-items: center;
justify-content: center;
background: #effbf1;
color: #35A93E;
font-size: 20px;
transition:
transform .35s ease,
background .35s ease;
}

.lop-faq-card[open] .lop-faq-plus {
transform: rotate(45deg);
background: #35A93E;
color: white;
}

.lop-faq-answer {
padding: 0 22px 20px;
color: #777;
font-size: 12px;
line-height: 1.8;
animation: lopFaqOpen .35s ease;
}

@keyframes lopFaqOpen {
from {
opacity: 0;
transform: translateY(-5px);
}
to {
opacity: 1;
transform: translateY(0);
}
}

.lop-faq-button {
border: none;
background: transparent;
color: #35A93E;
font-weight: 700;
font-size: 13px;
}

.lop-faq-button {
text-decoration: underline;
}

/* =========================================================
CONTACT
========================================================= */

.lop-contact-section {
position: relative;
overflow: hidden;
padding: 85px 0;
color: white;
background:
linear-gradient(
125deg,
#16351D,
#23852e,
#35A93E,
#16351D
);
background-size: 300% 300%;
animation: lopContactGradient 12s ease infinite;
}

@keyframes lopContactGradient {
0%,100% {
background-position: 0% 50%;
}
50% {
background-position: 100% 50%;
}
}

.lop-contact-section h2 {
font-size: 38px;
font-weight: 900;
}

.lop-contact-section p {
max-width: 680px;
margin: 18px auto 0;
color: rgba(255,255,255,.82);
line-height: 1.8;
font-size: 14px;
}

.lop-contact-label {
display: inline-block;
font-size: 10px;
font-weight: 800;
letter-spacing: .2em;
opacity: .8;
}

.lop-contact-button {
position: relative;
overflow: hidden;
margin-top: 30px;
padding: 13px 28px;
border: none;
border-radius: 12px;
background: white;
color: #23852e;
font-weight: 800;
box-shadow:
0 15px 35px rgba(0,0,0,.16);
transition:
transform .35s ease,
box-shadow .35s ease;
}

.lop-contact-button {
transform:
translateY(-5px)
scale(1.025);
box-shadow:
0 22px 45px rgba(0,0,0,.22);
}

.lop-contact-button span {
margin-left: 8px;
}

.lop-contact-orb {
position: absolute;
border-radius: 50%;
background: rgba(255,255,255,.07);
pointer-events: none;
}

.lop-contact-orb-one {
width: 350px;
height: 350px;
left: -170px;
top: -180px;
animation: lopContactOrb 8s ease-in-out infinite;
}

.lop-contact-orb-two {
width: 270px;
height: 270px;
right: -120px;
bottom: -150px;
animation: lopContactOrb 10s ease-in-out infinite reverse;
}

@keyframes lopContactOrb {
0%,100% {
transform: translate3d(0,0,0);
}
50% {
transform: translate3d(30px,25px,0);
}
}

/* =========================================================
VIDEO
========================================================= */

.lop-video-modal {
position: fixed;
inset: 0;
z-index: 99999;
display: flex;
align-items: center;
justify-content: center;
padding: 20px;
background: rgba(0,0,0,.78);
backdrop-filter: blur(8px);
}

.lop-video-box {
position: relative;
width: 100%;
max-width: 950px;
overflow: hidden;
border-radius: 22px;
background: #000;
box-shadow:
0 30px 80px rgba(0,0,0,.35);
}

.lop-video-box video {
width: 100%;
max-height: 80vh;
display: block;
}

.lop-video-close {
position: absolute;
top: 12px;
right: 12px;
z-index: 5;
width: 40px;
height: 40px;
border: none;
border-radius: 50%;
background: rgba(0,0,0,.65);
color: white;
font-size: 20px;
cursor: pointer;
}

/* =========================================================
SLICK
========================================================= */

.lop-home-page .slick-slider {
perspective: 1400px;
}

.lop-home-page .slick-slide {
transition:
opacity .4s ease,
transform .4s ease;
}

.lop-home-page .slick-slide > div {
height: 100%;
}

.lop-home-page .slick-dots {
bottom: 12px;
}

.lop-home-page .slick-dots li button {
color: #35A93E;
font-size: 8px;
}

.lop-home-page .slick-prev,
.lop-home-page .slick-next {
z-index: 10;
}

.lop-home-page .slick-prev,
.lop-home-page .slick-next {
color: #35A93E;
}

/* =========================================================
IMAGE SHINE
========================================================= */

.lop-image-shine {
position: absolute;
inset: 0;
pointer-events: none;
background:
linear-gradient(
110deg,
transparent 20%,
rgba(255,255,255,.38) 48%,
transparent 65%
);
transform: translateX(-130%);
transition: transform .8s ease;
}

.lop-about-image-frame .lop-image-shine,
.lop-ai-image-card .lop-image-shine,
.lop-service-card .lop-image-shine {
transform: translateX(130%);
}

/* =========================================================
MOBILE
========================================================= */

@media (max-width: 900px) {

.lop-trust-grid {
grid-template-columns: 1fr;
}

.lop-trust-item {
min-height: 62px;
}

.lop-step-line {
display: none;
}

.lop-membership-card {
height: 145px;
min-height: 145px;
}

}

@media (max-width: 640px) {

.lop-about-section,
.lop-why-section,
.lop-ai-section,
.lop-how-section,
.lop-account-section,
.lop-services-section,
.lop-testimonial-section,
.lop-faq-section {
padding-top: 50px;
padding-bottom: 50px;
}

.lop-contact-section {
padding: 65px 0;
}

.lop-contact-section h2 {
font-size: 28px;
}

.lop-company-card-inner {
height: 68px;
}

.lop-company-logo {
height: 42px;
}

.lop-service-image-box {
height: 220px;
}

.lop-testimonial-card {
min-height: 320px;
}

.lop-ai-image-card {
border-radius: 22px;
}

/* Compact membership on mobile */
.lop-membership-section {
padding: 30px 0 35px;
}

.lop-membership-section
.grid.grid-cols-1.sm:grid-cols-2.lg:grid-cols-4 {
gap: 10px !important;
margin-top: 18px !important;
}

.lop-membership-card {
height: 145px;
min-height: 145px;
}

.lop-benefit-wrapper {
margin-top: 18px !important;
}

}

/* =========================================================
REDUCED MOTION
========================================================= */

@media (prefers-reduced-motion: reduce) {

*,
*::before,
*::after {
animation-duration: .01ms !important;
animation-iteration-count: 1 !important;
transition-duration: .01ms !important;
}

}
/* MARATHON REGISTRATION */
.marathon-registration-section {
  padding: 55px 20px;
  background: linear-gradient(135deg, #f0fff2, #ffffff);
}

.marathon-registration-card {
  max-width: 1000px;
  margin: auto;
  padding: 35px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  background: #fff;
  border: 1px solid #d9f0dc;
  border-radius: 24px;
  box-shadow: 0 15px 40px rgba(24, 100, 35, 0.1);
}

.marathon-registration-content {
  flex: 1 1 300px;
}

.marathon-registration-label {
  color: #35a93e;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 2px;
}

.marathon-registration-content h2 {
  margin: 12px 0;
  color: #16351d;
  font-size: 32px;
  font-weight: 800;
}

.marathon-registration-content p {
  color: #647067;
  line-height: 1.8;
}

.marathon-register-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 20px;
  padding: 12px 22px;
  border: 0;
  cursor: pointer;
  font: inherit;
  color: white;
  background: linear-gradient(120deg, #35a93e, #188b25);
  border-radius: 10px;
  text-decoration: none;
  font-weight: 700;
}

.marathon-register-button:hover {
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 18px rgba(24, 139, 37, 0.22);
}

.marathon-quick-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 7px;
  margin-top: 12px;
}

.marathon-quick-actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 10px;
  border: 1px solid #cfe8d2;
  border-radius: 8px;
  background: #f4fff5;
  color: #216d2a;
  font-size: 11px;
  line-height: 1.2;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s ease;
}

.marathon-quick-actions button:hover {
  color: #fff;
  background: #35a93e;
  border-color: #35a93e;
  transform: translateY(-1px);
}

.marathon-action-message {
  margin-top: 9px;
  color: #23852e;
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.marathon-qr-card {
  flex: 0 1 240px;
  padding: 20px;
  text-align: center;
  background: white;
  border: 1px solid #e2eee4;
  border-radius: 18px;
}

.marathon-qr-card canvas {
  display: block;
  max-width: 100%;
  height: auto;
  margin: auto;
}

.marathon-qr-card h3 {
  margin-top: 12px;
  color: #16351d;
  font-size: 16px;
  font-weight: 700;
}

.marathon-qr-card p {
  margin-top: 6px;
  color: #647067;
  font-size: 12px;
}

@media (max-width: 640px) {
  .marathon-registration-section {
    padding: 35px 15px;
  }

  .marathon-registration-card {
    padding: 22px;
    justify-content: center;
  }

  .marathon-registration-content {
    text-align: center;
  }

  .marathon-quick-actions {
    justify-content: center;
  }

  .marathon-quick-actions button {
    padding: 8px 9px;
    font-size: 10px;
  }

  .marathon-qr-card {
    flex-basis: 100%;
  }
}


/* FLOATING SHARE AND QR CODE */
.lop-floating-share {
  position: fixed;
  right: 22px;
  bottom: 24px;
  z-index: 99990;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  font-family: inherit;
}

.lop-floating-share-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 13px 19px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 50px;
  background: linear-gradient(135deg, #35a93e, #176b25);
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 10px 30px rgba(22, 95, 35, 0.3);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.lop-floating-share-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 35px rgba(22, 95, 35, 0.4);
}

.lop-floating-share-icon {
  font-size: 21px;
  line-height: 1;
}

.lop-share-panel {
  position: relative;
  width: 290px;
  max-width: calc(100vw - 30px);
  padding: 23px 19px;
  border: 1px solid #dcefe0;
  border-radius: 22px;
  background: #fff;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
  animation: lopShareOpen 0.25s ease;
}

@keyframes lopShareOpen {
  from { opacity: 0; transform: translateY(12px) scale(0.97); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.lop-share-close {
  position: absolute;
  top: 8px;
  right: 12px;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 50%;
  background: #f0f7f1;
  color: #16351d;
  font-size: 24px;
  cursor: pointer;
}

.lop-share-panel h3 {
  margin: 5px 0 7px;
  color: #16351d;
  font-size: 20px;
  font-weight: 800;
}

.lop-share-panel > p {
  margin-bottom: 15px;
  color: #68766b;
  font-size: 12px;
  line-height: 1.6;
}

.lop-share-qr {
  display: flex;
  justify-content: center;
  margin: 12px auto;
  padding: 10px;
  width: fit-content;
  border: 1px solid #e4eee5;
  border-radius: 14px;
  background: #fff;
}

.lop-share-qr canvas {
  display: block;
  max-width: 100%;
  height: auto;
}

.lop-share-url {
  overflow-wrap: anywhere;
  max-height: 55px;
  overflow-y: auto;
  margin: 12px 0;
  padding: 9px;
  border-radius: 9px;
  background: #f5f8f5;
  color: #59665b;
  font-size: 10px;
  line-height: 1.5;
  text-align: left;
}

.lop-share-action {
  display: block;
  width: 100%;
  margin-top: 9px;
  padding: 11px 14px;
  border: none;
  border-radius: 10px;
  background: #35a93e;
  color: white;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
  transition: transform 0.2s ease, background 0.2s ease;
}

.lop-share-action:hover {
  transform: translateY(-2px);
  background: #23852e;
}

.lop-share-action-secondary { background: #16351d; }
.lop-share-action-secondary:hover { background: #285d32; }

.lop-share-panel .lop-share-message {
  margin: 12px 0 0;
  color: #23852e;
  font-size: 12px;
  font-weight: 700;
  overflow-wrap: anywhere;
}

@media (max-width: 640px) {
  .lop-floating-share { right: 12px; bottom: 15px; }
  .lop-floating-share-button { padding: 12px 15px; font-size: 12px; }
  .lop-share-panel { width: 280px; }
}

  `}</style>

      {/* FLOATING QR CODE AND SHARE PANEL */}
      <div className="lop-floating-share">
        {showSharePanel && (
          <div
            className="lop-share-panel"
            role="dialog"
            aria-label="Share LifeOnPlus website"
          >
            <button
              type="button"
              className="lop-share-close"
              onClick={() => {
                setShowSharePanel(false);
                setShareMessage("");
              }}
              aria-label="Close share panel"
            >
              ×
            </button>

            <h3>Share Marathon Registration</h3>
<p>Scan the QR code or share the Marathon registration link.</p>

            <div className="lop-share-qr">
              <QRCodeCanvas
                value={MARATHON_REGISTRATION_URL}
                size={160}
                level="H"
                includeMargin={true}
              />
            </div>

            <div className="lop-share-url">
  {MARATHON_REGISTRATION_URL}
</div>

            <button
              type="button"
              className="lop-share-action lop-copy-action"
              onClick={handleCopyMarathonLink}
            >
              Copy Link
            </button>

            <button
              type="button"
              className="lop-share-action lop-share-action-secondary"
              onClick={handleShareMarathonLink}
            >
              Share Website
            </button>

            {shareMessage && (
              <p className="lop-share-message" role="status">
                {shareMessage}
              </p>
            )}
          </div>
        )}

        <button
          type="button"
          className="lop-floating-share-button"
          onClick={() => {
            setShowSharePanel((previous) => !previous);
            setShareMessage("");
          }}
          aria-expanded={showSharePanel}
          aria-label="Open QR code and share options"
        >
          <span className="lop-floating-share-icon">↗</span>
          <span>Share / QR</span>
        </button>
      </div>
    </div>
  );
};

export default Home;
